import { CtaBlock } from '@design-system/cta-block';
import { ExtendableImage } from '@design-system/extendable-image';
import { HeadingBlock } from '@design-system/heading-block';
import classNames from 'classnames';
import React, { forwardRef } from 'react';

import { getCardsCategoriesLabels } from '~/utils/getCardsCategoriesLabels';

import { CardLabel } from '../card/components/card-label/card-label';
import { AssetItemProps } from './models';

export const AssetItem = forwardRef<
  HTMLDivElement & HTMLLIElement,
  AssetItemProps
>(
  (
    {
      className,
      headingBlock,
      image,
      align = 'start',
      ctaBlock,
      mediaVariant = 'rounded',
      tag: Tag = 'div',
      isHorizontal,
      categories,
    },
    ref
  ) => {
    const headingBlockProps = { ...headingBlock, align };

    const categoriesLabels = getCardsCategoriesLabels(categories);

    return (
      <Tag
        ref={ref}
        className={classNames('cds-asset-item', className, {
          [`cds-asset-item--align-${align}`]: align,
          'cds-asset-item--horizontal': isHorizontal,
        })}
        data-testid="cds-asset-item"
      >
        <div
          className={classNames('cds-asset-item__content', {
            'cds-asset-item__content--horizontal': isHorizontal,
          })}
        >
          <div className="cds-asset-item__content-inner">
            <div className="cds-card__label-group">
              {categoriesLabels.length > 0 &&
                categoriesLabels
                  .slice(0, 3)
                  .map((cardLabelProps) => (
                    <CardLabel
                      key={cardLabelProps.labelContent}
                      {...cardLabelProps}
                    />
                  ))}
            </div>
            <HeadingBlock {...headingBlockProps} />
            {ctaBlock && <CtaBlock align={align} {...ctaBlock} />}
          </div>
          <div />
        </div>
        {image && (
          <div
            className={classNames(
              'cds-asset-item__media',
              `cds-asset-item__media--${mediaVariant}`,
              {
                'cds-asset-item__media--horizontal': isHorizontal,
              }
            )}
          >
            <ExtendableImage
              {...image}
              className="cds-asset-item__media-image"
            />
          </div>
        )}
      </Tag>
    );
  }
);
